import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getFilesApi} from '../api/files-api';
import {filesKeys} from '../query-keys';
import type {ListFilesParams} from '../types/files-types';

export function useFiles(
  params?: ListFilesParams,
  options?: {enabled?: boolean}
) {
  const tenantId = useRequiredTenantId();
  const api = getFilesApi();

  return useQuery({
    queryKey: filesKeys.files.filtered(tenantId, params ?? {}),
    queryFn: async () => api.listFiles(params),
    enabled: options?.enabled ?? true,
  });
}
